// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33DSi","colBig":"styles_colBig__2FYj-","colSmall":"styles_colSmall__izjE_"};